/* 防止message出现多次 */
import { Message } from 'element-ui';

var message = function (options) {
    if (document.getElementsByClassName('el-message').length !== 0) {
        Message.closeAll();
    }
    Message(options)
} 
var tipType = ['success', 'warning', 'info', 'error'];
tipType.forEach(function (type) {
    message[type] = function(options) {
        if (document.getElementsByClassName('el-message').length !== 0) {
            Message.closeAll();
        }
        Message[type](options)
    }
})
export default message


// WEBPACK FOOTER //
// ./static/js/lib/resetMessage.js